import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    careTagsList: 'mt-5 md:mt-7',
    gammaSeoBlock: 'container my-10 md:my-15',
    filtersWrapper: 'bg-white pt-6 pb-1 md:pt-10 md:pb-2',
    filters: 'relative container flex items-center justify-between',
    products:
      'relative container mt-8 grid grid-cols-2 gap-x-2 gap-y-12 sm:grid-cols-3 md:grid-cols-4 lg:gap-x-10 lg:gap-y-15',
    pagination: 'flex-center container mt-12 flex',
    notFound: 'container mt-12 flex flex-col gap-24',
    notFoundTitle: 'heading-2xl',
    notFoundDescription: 'heading-m mt-2',
    sortSelect: 'max-w-46.5 md:max-w-59',
    bottomSeoBlock: 'container mt-16 md:mt-30'
  },
  variants: {
    notFixed: {
      true: 'mt-6'
    },
    isSearchPage: {
      true: {
        notFound: 'mt-0'
      }
    }
  }
});
